module.exports = __webpack_public_path__ + "1a892077b7888eb0dcd894877a8ae435.svg";